<template>
  <div class="paddingbottom50">
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="加载完毕"
        @load="onLoad"
      >
        <div class="">
          <div
            v-for="(item,index) in List"
            :key="index"
            class=" setWhite"
          >
            <div style="text-align: center;font-size: 20px;font-weight: 700;padding:10px;background-color:#f1f1f1;">
              {{item.title}}
            </div>
            <van-cell-group>
              <van-cell
                title="营员"
                :value="item.p_names"
              />
              <van-cell
                title="异常上报时间"
                :value="item.created_at"
              />
              <van-cell
                title="提交人"
                :value="item.uploader_name"
              />
            </van-cell-group>
            <div style="display:flex;justify-content: space-around;">

              <div
                class="see-more"
                @click="seeMore(item.id)"
              >
                点击查看
              </div>

            </div>

          </div>
        </div>
      </van-list>
    </van-pull-refresh>

  </div>
</template>
<script>
import { Dialog, Toast } from 'vant'
export default {
  data() {
    return {
      List: [],
      page: 0,
      limits: 10,
      loading: false,
      finished: false,
      isLoading: false,
      total: 0,
      project_id: '',
    }
  },
  created() {
    this.project_id = this.$route.query.project_id

    this.loadData()
    let config = {
      sharePath: '/abnormal',
    }
    this.wxShare(config)
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.$toast('刷新成功')
        this.isLoading = false
        this.reload()
      }, 500)
    },
    onLoad() {
      if (this.List.length < this.total) {
        setTimeout(() => {
          this.loadData()
        }, 500)
        return
      }
      this.loading = false
      this.finished = true
    },
    reload() {
      this.page = 0
      this.List = []
      this.loading = false
      this.finished = false
      this.onLoad()
    },
    loadData() {
      let that = this
      that.page++
      this.$axios
        .get('/project/issuelist', {
          params: {
            'per-page': 20,
            page: this.page,
            project_id: this.project_id,
          },
        })
        .then((res) => {
          let data = res.data.data.list
          this.List = [...that.List, ...data]
          this.total = res.data.data.total
          that.loading = false
          if (res.data.data.total == 0) {
            that.finished = true
          }
        })
    },
    seeMore(id) {
      this.$router.push({
        path: 'abnormalDetail',
        query: {
          id: id,
        },
      })
    },
  },
}
</script>
<style scoped>
.see-more {
  display: inline-block;
  padding: 10px;
  width: 40%;
  text-align: center;
  background-color: #3399ff;
  color: #fff;
}
</style>